import React from 'react';

interface LogoProps {
  /** "mark": solo el casco. "full": casco + wordmark "OBROS". */
  variant?: 'mark' | 'full';
  /** "color": naranja (+ texto negro en full). "light": blanco, para fondos oscuros/de color. "dark": negro. */
  tone?: 'color' | 'light' | 'dark';
  className?: string;
}

const markSrc: Record<'color' | 'light' | 'dark', string> = {
  color: '/logo/icono.svg',
  light: '/logo/icono-blanco.svg',
  dark: '/logo/icono.svg',
};

const fullSrc: Record<'color' | 'light' | 'dark', string> = {
  color: '/logo/logo-color.png',
  light: '/logo/logo-blanco.png',
  dark: '/logo/logo-negro.png',
};

export const Logo: React.FC<LogoProps> = ({ variant = 'full', tone = 'color', className = 'h-8' }) => (
  <img src={variant === 'mark' ? markSrc[tone] : fullSrc[tone]} alt="Obros" className={`${className} w-auto object-contain`} />
);
